import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { environment } from 'src/environments/environment.development';
import { CategoryService } from '../entities/service';

interface ApiResponse {
  status: string;
  data: CategoryService[];
}

@Injectable({
  providedIn: 'root'
})
export class ServiceCategoryService {

  constructor(private http: HttpClient) { }

  private apiServicesUrl = environment.cfgApiBaseUrl;
  private serviceCategoryServiceUrl = this.apiServicesUrl + '/service';

  getServices(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.serviceCategoryServiceUrl)
    .pipe(
      catchError(this.handleError<ApiResponse>('getServices'))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
